import React from 'react'
import { useTranslation } from 'react-i18next'
import DazzedParagraph11 from 'components/common/text/DazzedParagraph11'
import { getRawScoreValue, isScoreFrozen } from 'logic/oralScoresLogic'

const OralScoreFrozenIndicator = ({ oralScores, scoreKey = 'oral_hygiene_score' }) => {
  const { t } = useTranslation()
  if (!isScoreFrozen(oralScores, scoreKey)) return null

  const rawValue = getRawScoreValue(oralScores, scoreKey)
  return (
    <DazzedParagraph11 color="var(--text-color-62)">
      {t(
        `pages.patients.selectedPatient.timelineV2.oralScores.${
          Number.isFinite(rawValue) ? 'frozenWithRaw' : 'frozen'
        }`,
        {
          rawValue
        }
      )}
    </DazzedParagraph11>
  )
}

export default OralScoreFrozenIndicator
